export default class PreferenceModel {
    public preferenceId: string = "";
    public categories: string[] = [];
    public source: string = "";
}